import React, { useEffect, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { subscribeToasts } from "./toast";

// Affiche les toasts émis via toast()/toast.success()/toast.error().
// Monté une seule fois à la racine (App.js).
export default function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    return subscribeToasts((t) => {
      setItems((prev) => [...prev, t]);
      setTimeout(() => {
        setItems((prev) => prev.filter((x) => x.id !== t.id));
      }, 4000);
    });
  }, []);

  return (
    <ToastContainer
      position="top-end"
      className="p-3"
      style={{ position: "fixed", zIndex: 9999 }}
    >
      {items.map((t) => (
        <Toast key={t.id} bg={t.variant === "error" ? "danger" : "success"}>
          <Toast.Body style={{ color: "#fff", fontWeight: 500 }}>{t.message}</Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
}
